var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("h2", [_vm._v("3D Model Documents")]),
                  ]),
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex justify-end py-0",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            disabled: _vm.$helpers.notHasPermission(
                              _vm.$helpers.PERMISSION_KEYS
                                .SITE_SETUP_EDIT_DETAILS,
                              _vm.$route.params?.siteId
                            ),
                          },
                          on: { click: _vm.addDocument },
                        },
                        [_vm._v("Add 3D Model Document")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-col", { attrs: { cols: "12" } }, [
            _c("table", { staticClass: "foex-table" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("Title")]),
                  _c("th", [_vm._v("File Name")]),
                  _c("th", [_vm._v("Date")]),
                  _c("th", [_vm._v("Action")]),
                ]),
              ]),
              _c(
                "tbody",
                _vm._l(_vm.documents, function (document, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [_vm._v(_vm._s(document.title))]),
                    _c("td", [_vm._v(_vm._s(document.fileName))]),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.$helpers.formatDate(
                            document.created,
                            "yyyy-MM-dd hh:mm:ss a"
                          )
                        )
                      ),
                    ]),
                    _c(
                      "td",
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "" },
                            on: {
                              click: function ($event) {
                                return _vm.preview3DModel(document)
                              },
                            },
                          },
                          [
                            _c("v-icon", { attrs: { color: "primary" } }, [
                              _vm._v("mdi-eye"),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "mr-1",
                            attrs: { icon: "", small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.download3DModel(document)
                              },
                            },
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass:
                                  "admin-primary--text cursor-pointer",
                              },
                              [_vm._v("mdi-download")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteDocument(document)
                              },
                            },
                          },
                          [
                            _c("v-icon", { attrs: { color: "red" } }, [
                              _vm._v("mdi-delete"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                }),
                0
              ),
            ]),
          ]),
        ],
        1
      ),
      _c("ModelUploaderDocumentComponent", {
        ref: "modelUploaderDocumentComponentRef",
        attrs: { locationId: _vm.locationId },
        on: { fileUploaded: _vm.fileUploaded },
      }),
      _c("PreviewDocumentDialogComponent", {
        ref: "preview3DModelDocumentDialog",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }